<template>
    <div class="banner">
        <div class="text-white titulo_banner" style="width:450px;z-index: 5;text-align:center;position:absolute;left: 50%;margin-left:-210px;top:100px;">
            <h2 class="text-white" style="font-size:40px;">Nuestros Colaboradores</h2>
            <h4 class="text-white" style="font-size:20px;"><router-link to="/" class="text-white">Inicio</router-link> / Nuestros Colaboradores</h4>
        </div>
    </div>

    <section class="section review">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-sm-12 col-md-7">
                    <h3 class="header-title text-center" style="margin-bottom:70px">Nues<span class="subrayado">tros colabora</span>dores</h3>
                    
                    <div class="row mb-5" v-for="(item, index) in dataTableCollaborators" :key="index">
                        <div :class="index % 2 === 0 ? 'col-lg-6' : 'col-lg-6 order-lg-last'">
                            <div class="aos" :data-aos="'fade-up'" :data-aos-duration="500">
                                <div class="demand-professional">
                                    <p style="margin-top:10px">{{item.text}}</p>
                                </div>
                            </div>
                        </div>
                        <div :class="index % 2 === 0 ? 'col-lg-6' : 'col-lg-6 order-lg-first'">
                            <div class="" :data-aos="'fade-right'" :data-aos-duration="500">
                            <img :src="item.s3_url" :alt="'Img ' + index" class="img-fluid" style="width: 100%;">
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>

    <!-- Pie de Página -->
    <footeragv></footeragv>
  </template>
  <script>
  import axiosIns from '@/plugins/axios.js';
  import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
  import "vue3-carousel/dist/carousel.css";
  export default {
    data() {
      return {
        ourContributors: [
            {
                "title" : "Descripcion 1",
                "img" : "Hebert Custodio - Adminitración.jpg",
                "text" : "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
            },
            {
                "title" : "Descripcion2",
                "img" : "Jasmin Bravo -Comex.jpg",
                "text" : "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
            },
            {
                "title" : "Descripcion2",
                "img" : "Javier Limo.jpg",
                "text" : "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
            },
            {
                "title" : "Descripcion2",
                "img" : "Tania Martinez - Comex.jpg",
                "text" : "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
            },
        ],
        settings: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        breakpoints: {
          575: {
            itemsToShow: 1,
            snapAlign: "center",
          },
          // 700px and up
          767: {
            itemsToShow: 2,
            snapAlign: "center",
          },
          // 991px and up
          1024: {
            itemsToShow: 3.5,
            snapAlign: "center",
          },
        //   // 1024 and up
        //   1024: {
        //     itemsToShow: 4.9,
        //     snapAlign: "start",
        //   },
        },

        dataTableCollaborators: null,
        dataTableFiltCollaborators: null,
      };
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    mounted(){
        this.getCollaborators()
    },
    methods: {
        getCollaborators(){
            const yo = this
            yo.dataTableCollaborators = []
            const config = {
                method: 'get',
                url: '/talentoagv/readCollaborators/',
            }

            if(this.$store.getters.currentPublicLanguage == 'es'){
                yo.language = '1'
            }
            else if(this.$store.getters.currentPublicLanguage == 'en'){
                yo.language = '2'
            }

            axiosIns(config)
                .then(function (response) {
                console.log(response.data['result'])
                if (response.data['is_error'] === false){
                    let resultado = response.data['result']
                    for(let r of resultado){
                        if(r['key_idioma_id'] == yo.language){
                            yo.dataTableCollaborators.push(r)
                        }
                    }
                    // yo.dataTableCollaborators = response.data['result']
                }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function (){
                
                })
        },
    }
  };
  </script>
  <style>
  .banner{
      width: 100%;
      height: 280px;
      background-image: url('../../../../assets/img/fondo_principal_inicio.png');
      background-size: contain;
      background-position: center bottom;
  }

  .banner::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 280px;
      background-color: rgba(0, 0, 0, 0.4); /* Color negro semi-transparente */
  }

  .titulo{
      position: absolute;
      top:130px;
      left: 50%;
      margin-left: -100px;
      z-index: 5;
  }

  .descrip_atributo:hover {
    /* position: absolute;
    width: 100%;
    height: 100%; */
    background: none;
    opacity: 0; /* Inicialmente oculto */
    display: flex;
    /* justify-content: center;
    align-items: center; */
  }

  @media(max-width:480px){
        .titulo_banner{
            width:400px !important;
            margin-left:-200px !important;
        }
    }

    @media(max-width:400px){
        .titulo_banner{
            width:360px !important;
            margin-left:-180px !important;
        }
    }


</style>

  